export default __webpack_public_path__ + "static/media/spark_feature.afa20237.png";